import { render, staticRenderFns } from "./ColumnContentHistory.vue?vue&type=template&id=5277568e"
import script from "@/scripts/components/column/columnContentHistory.js?vue&type=script&lang=js&external"
export * from "@/scripts/components/column/columnContentHistory.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports